import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
interface Objct {
  version: string;
  systemPrompt: string;
  created_date: string;
  created_by_name: string;
}
interface DataI {
  tabLabel: string, 
  label: string, 
  content: string, 
  isEditing: boolean, 
  api?: string, 
  updated_date: string, 
  updated_by: string, 
  version_list: {}
}
@Component({
    selector: 'app-system-prompt-dialog',
    templateUrl: './system-prompt-dialog.component.html',
    styleUrl: './system-prompt-dialog.component.scss',
    standalone: false
})
export class SystemPromptDialogComponent {
  Data: DataI;
  version: string;
  systemPrompt: string;
  Obj: Objct;
  created_date: string;
  created_by_name: string;
  constructor(public dialogRef: MatDialogRef<SystemPromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.Data = data.tab;
    this.Obj = data.object;
    this.version = this.Obj.version;
    this.systemPrompt = this.Obj.systemPrompt;
    this.created_date = this.Obj.created_date;
    this.created_by_name = this.Obj.created_by_name;
  }
}
